/*
*###############################################################################
*Module Name                   : UserGroupsMaster.js                           #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               : I Dinisuru Balasuriya                         #
*Date                          : Monday, September 6th 2021, 12:14:16 am       #
*Copyright © 2021 myPOS Software Solution (pvt Ltd.)                           #
*###############################################################################
*/

import React, { useState, useEffect } from 'react'
import { MetaTags } from 'react-meta-tags'
import {
    Card,
    Col,
    Container,
    Row,
    CardBody,
} from 'reactstrap'

//**Importing required componant files   */
import Breadcrumb from 'components/Common/Breadcrumb'
import DPTopToolBar from 'framework/widgets/DPTopToolBar'
import UserGroupsMasterContent from './UserGroupsMasterContent'
import DPInfoBox from 'framework/layout/DPInfoBox'
import { Text } from "../../../framework/validators/TextValidation"
import DPAlert from "../../../framework/widgets/DPAlert"
import DPLoadingAlert from 'framework/widgets/DPLoadingAlert'
import DPPermission from 'framework/widgets/DPPermission'
import UserGroupDetNew from './UserGroupDetNew'
//**End Importing required componant files */

import { Context } from '../../../app-contexts/CommonContexts';
import { useHistory } from 'react-router-dom';
import { useContext } from 'react'

const UserGroupsMaster = (props) => {
    const [newMenu] = useState(localStorage.getItem(window.location.pathname))
    let history = useHistory();
    //*** User input related states */
    const [strUGroupCode, SetCode] = useState("");// Set Code
    const [strUGroupDesc, SetDescription] = useState("")//Set Description
    const [IsActive, SetActive] = useState(true)//Set Active state
    //*** End User input related states */

    //*** User Activity related states*/
    const [show, setShow] = useState(false)
    const [AlertMsg, setAlertMsg] = useState('')
    const [AlertColor, setAlertColor] = useState('')
    const [Post, SetPost, getPost] = useState([])

    const [modal_xlarge, setmodal_xlarge] = useState(false)
    const [disabled, setDisabled] = useState(false)
    const [disabledCode, setDisabledCode] = useState(false)
    const [saveEnable, setSaveEnable] = useState(true)
    const [crEnable, setCrEnable] = useState(false)
    const [crBy, setCrBy] = useState("")
    const [mdBy, setMdBy] = useState("")
    const [crDate, setCrDate] = useState("")
    const [mdDate, setMdDate] = useState("")
    const [detailsEnable, SetDetailsEnable] = useState(false)
    const [menuTable, setMenuTable] = useState(false)

    //**End User Activity related states*/
    const [access1, setAccess] = useState(false)
    const [modify1, setModify] = useState(false)
    const [dele1, setDele] = useState(false)
    const [process1, setProcess] = useState(false)
    const [print1, setPrint] = useState(false)
    const [create1, setCreate] = useState(false)


    //*** End User activity related staes */

    //Alert Parameter
    const [sweetAlertShow, setsweetAlertShow] = useState(false)
    const [AlertDescription, setAlertDescription] = useState(false)
    const [AlertConfirmOption, setAlertConfirmOption] = useState(0)
    const [ErrorMsg, setErrorMsg] = useState('')
    const [addNew, SetAddNew] = useState(true)
    const [table, Settable] = useState()

    //*****Menu Rights Start*/
    const [menuAccess, SetMenuAccess] = useState(false)
    const [menuCreate, SetMenuCreate] = useState(false)
    const [menuDelete, SetMenuDelete] = useState(false)
    const [menuModify, SetMenuModify] = useState(false)
    const [menuPrint, SetMenuPrint] = useState(false)
    const [menuProcess, SetMenuProcess] = useState(false)
    const [menuName, SetMenuName] = useState("")
    const [parentName, SetParentName] = useState("")
    const [dpAlertShow, SetDpAlertShow] = useState(false)
    const [dpDescription, SetDpDescription] = useState("")
    const [LocationCode, setLocationCode] = useState("")
    const [LogUserType, setLogUserType] = useState("")
    const [LogCompanyCode, setLogCompanyCode] = useState("")
    const [menuCode, SetMenuCode] = useState("")
    const [deleteEnable, SetDeleteEnable] = useState(false)
    //*****Menu Rights End */

    /**********Loading Alert */
    const [loadingAlert, SetLoadingAlert] = useState(false)
    const [loadingAlertTitle, SetLoadingAlerttitle] = useState("")
    /**********End Loading Alert */

    //User Permission related usestates
    const [permissionAlertShow, setPermissionAlertShow] = useState(false)
    const [permissionAlertTitle, setPermissionAlertTitle] = useState("")
    const [permissionReasonShow, setPermissionReasonShow] = useState(false)
    const [permissionName, setPermissionName] = useState("")
    const [permissionPassword, setPermissionPassword] = useState("")
    const [permissionNameDisable, setPermissionNameDisable] = useState(false)
    const [clearOnEdit, setClearOnEdit] = useState(false)

    const [Reason, setReason] = useState("Created")
    const [editEnable, SetEditEnable] = useState(false)

    const [currentPage, setCurrentPage] = useState(1)
    const [helpUrl, setHelpUrl] = useState("")
    //import from contexts
    const {
        isHeadOffice, getMenuDetails, addtoFavourite
    } = useContext(Context);
    //import from contexts
    var time = process.env.REACT_APP_ALERTTIMEOUT

    const authToken = localStorage.getItem("authToken")
    const ApiURL = window.Links.ApiURL


    //*** table data set*/
    React.useEffect(() => {


        function getMenuList() {

            fetch(`${ApiURL}Menu/All`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${authToken}`
                }
            }).then(Response => Response.json())
                .then(responseData => {
                    if (responseData.success == true) {
                        {
                            setarRow([])

                            let modifiedRows = []

                            const newArray = [...responseData.data]
                            SetPost(newArray)
                            SetPost(state => {
                                state.map((dr, index) => {

                                    modifiedRows.push({
                                        id: index + 1,
                                        menu: dr.menuCode,
                                        menunname: dr.menuName,
                                        show: dr.menuRights,
                                        access: dr.blnAccess == "1" ? true : false,
                                        create: dr.blnCreate == "1" ? true : false,
                                        modify: dr.blnModify == "1" ? true : false,
                                        dele: dr.blnDelete == "1" ? true : false,
                                        process: dr.blnProcess == "1" ? true : false,
                                        permi: ""
                                    })
                                })

                                setarRow(modifiedRows == undefined || modifiedRows.length == 0 ? [] : modifiedRows)
                                setInitialTable(modifiedRows == undefined || modifiedRows.length == 0 ? [] : modifiedRows)
                                setMenuTable(modifiedRows == undefined || modifiedRows.length == 0 ? [{ id: 1 }] : modifiedRows)
                                Settable(false)
                                return state
                            })
                        }
                    }
                })
        }



        async function getMenuRights() {
            var obj = JSON.parse(localStorage.getItem("authUser"))
            var LogUserType = obj[2]
            var menuDetail = await getMenuDetails(window.location.pathname + window.location.search)
            var menu = menuDetail && menuDetail.menuTag ? menuDetail.menuTag : history.push('/dashboard');
            var parentname = menuDetail?.parentName
            SetParentName(parentname)
            var LocationCode = obj[3]
            var CompanyCode = obj[5]
            setLocationCode(LocationCode)
            setLogUserType(LogUserType)
            setLogCompanyCode(CompanyCode)

            var requestOptions = {
                method: 'GET',
                headers: {
                    "Authorization": `Bearer ${authToken}`
                },
                redirect: 'follow'
            };

            fetch(`${ApiURL}login/menu/${LogUserType}/${menu}`, requestOptions)
                .then(response => response.json())
                .then(result => {

                    SetMenuAccess(result.data.strMenuAccessRight)
                    SetMenuCreate(result.data.strMenuCreateRight)
                    SetMenuDelete(result.data.strMenuDeleteRight)
                    SetMenuModify(result.data.strMenuModifyRight)
                    SetMenuPrint(result.data.strMenuPrintRight)
                    SetMenuProcess(result.data.strMenuProcessRight)
                    SetMenuName(result.data.strMenuName)
                    SetMenuCode(result.data.strMenuTag)
                    setPermissionReasonShow(result.data.strMenuReasonShow)
                    setHelpUrl(result.data.strHelpUrl)
                }).catch(error =>
                    console.log('error', error)
                );

        }

        getMenuRights()
        getMenuList()


    }, [table])


    useEffect(async () => {
        var obj = JSON.parse(localStorage.getItem("authUser"))
        var LogUserType = obj[2]
        var LocationCode = obj[3]
        var LocationName = obj[4]
        var CompanyCode = obj[5]
        var menuDetail = await getMenuDetails(window.location.pathname + window.location.search)
        var menu = menuDetail && menuDetail.menuTag ? menuDetail.menuTag : history.push('/dashboard');
        var parentname = menuDetail?.parentName
        var menuTAG = ""
        const AuditLog = {
            "strMenuCode": menu,
            "strUserName": LogUserType,
            "strLocCode": LocationCode,
            "strComcode": CompanyCode,
            "strReason": ""
        }
        var requestOptions = {
            method: 'POST',
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${authToken}`
            },
            body: JSON.stringify(AuditLog),
        };

        fetch(`${ApiURL}login/menu/audit`, requestOptions)
            .then(async (response) => await response.json())
            .then(result => {
                console.log(result)
            }).catch(error =>
                console.log('error', error)
            );

    }, [])

    //*** Get and Set values when user search code */
    const getData = (searchData) => {

        if (searchData == "" ) return

        if (validateSpecialCharacters(searchData) == true) {
            SetCode("")
            return
        }

        if (searchData !== "") {
            SetLoadingAlert(true)
            SetLoadingAlerttitle("Fetching...")
            fetch(`${ApiURL}UserGroup/search/${searchData}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${authToken}`
                }
            })
                .then(Response => Response.json())
                .then(responseData => {
                    SetLoadingAlert(false)
                    if (responseData.success === true) {

                        setarRow([])
                        setShow(false)
                        let loadedMenues = [...arRow]
                        let newMenues = []
                        setClearOnEdit(prev => !prev)
                        SetDescription(responseData.data[0].name),
                            SetActive(responseData.data[0].status),
                            setCrBy(responseData.data[0].createdBy),
                            setCrDate(responseData.data[0].createdDate),
                            setMdBy(responseData.data[0].modifiedBy),
                            setMdDate(responseData.data[0].modifiedDate),
                            SetUserGroupDet(responseData.data[0].usergroupdetails),
                            responseData.data[0].usergroupdetails.map((dr) => {
                                let rightShow = '';
                                loadedMenues.map((r) => {
                                    if (dr.ugD_MENUTAG == r.menu) {
                                        rightShow = r.show
                                    }
                                })
                                newMenues.push({ id: newMenues.length + 1, menu: dr.ugD_MENUTAG, menunname: dr.ugD_MENUITEM_MENUNAME, permi: dr.ugD_MENURIGHT, show: rightShow })
                            })

                        responseData.data[0].usergroupdetails.map((dr) => {
                            loadedMenues = loadedMenues.filter((r) => {
                                return r.menu != dr.ugD_MENUTAG
                            })
                        })

                        loadedMenues.map((r) => {
                            newMenues.push({ id: newMenues.length + 1, menu: r.menu, menunname: r.menunname, permi: "", show: r.show })
                        })

                        newMenues.sort((a, b) => a.menu - b.menu)
                        setCurrentPage(1)
                        SetAddNew(false)
                        setarRow(newMenues == undefined || newMenues.length == 0 ? [{ id: 1 }] : newMenues)
                        setInitialTable(newMenues == undefined || newMenues.length == 0 ? [{ id: 1 }] : newMenues)
                        setDisabled(true)
                        setDisabledCode(true)
                        setSaveEnable(false)
                        SetDetailsEnable(true)
                        setCrEnable(true)
                        SetDeleteEnable(true)
                        setReason("Updated")
                        SetEditEnable(true)


                    } else {
                        setDisabledCode(false)
                        displayAlertMessage('danger', "Record Not Found !");
                    }
                })
        }
    }
    //*** End useEffect */

    function tog_xlarge() {
        setmodal_xlarge(!modal_xlarge)
        removeBodyCss()
    }

    //removebodyCss function
    function removeBodyCss() {
        document.body.classList.add("no_padding")
    }

    //**Set Value for details */
    const [arRow, setarRow] = useState([])
    const [initialTable, setInitialTable] = useState([])
    const [arUserGroupDet, SetUserGroupDet] = useState([])

    //save button function
    const handlesave = e => {
        // e.preventDefault()

        if (addNew == false && menuModify != true) {
            SetDpDescription("You don't have permission to Edit !");
            SetDpAlertShow(true)
            return
        }
        if (addNew == true && menuCreate != true) {
            SetDpDescription("You don't have permission to Save !");
            SetDpAlertShow(true)
            return
        }

        if (strUGroupCode == "") {
            displayAlertMessage('danger', "Please Enter User Group Master Code !")
            return;
        }
        if (strUGroupDesc == "") {
            displayAlertMessage('danger', "Please Enter description")
            return;
        }

        var userDet = [];

        for (let i = 0; i < arRow.length; i++) {
            userDet = userDet.concat(UserGroupDetBuilder(strUGroupCode, arRow[i].menu, arRow[i].permi))
        }

        var ActiveStat = IsActive == "1" ? true : false; //checking active sate
        const UserGroupMaster = {
            "strUserGroupCode": strUGroupCode,
            "strUserGroupName": strUGroupDesc,
            "IsActive": ActiveStat,
            "strMenuCode": menuCode,
            "strLoggedCompany": LogCompanyCode,
            "strLoggedLocation": LocationCode,
            "strReason": Reason,
            "USERGROUPDETAILS": userDet,
            "strCreateBy": LogUserType,
            "strMenuCode": menuCode,
            "blAddNew": addNew
        }
        //loading alert show
        SetLoadingAlert(true)
        if (addNew == true) {
            SetLoadingAlerttitle("Saving...")
        } else {
            SetLoadingAlerttitle("Updating...")
        }

        fetch(`${ApiURL}UserGroup`,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${authToken}`
                },
                body: JSON.stringify(UserGroupMaster)

            }
        ).then(Response => {
            if (Response.status == "200") {
                SetLoadingAlert(false)
                Response.json()
                    .then(responseData => {
                        if (responseData.data == "Record Already Exsist!") {
                            displayAlertMessage('danger', responseData.data)
                        } else if (responseData.data == "Code Already Exsist!") {
                            displayAlertMessage('danger', responseData.data)
                        } else {
                            displayAlertMessage('success', responseData.data)
                            ClearItem()

                        }
                    }
                    )
            } else if (Response.status == "400") {
                SetLoadingAlert(false)
                Response.json()
                    .then(responseData => {
                        setErrorMsg(responseData.msg)
                    })
                setDisabled(false)
                setDisabledCode(false)
                displayAlertMessage('danger', "Oops something went wrong !")
            } else {
                SetLoadingAlert(false)
                ClearItem()
            }
        }).catch(error => {
            console.log(error.message)
            SetLoadingAlert(false)
        })

        //***save/update end */
    }

    //*** Get user selected row details */
    const GetSelectRow = (e, row, isSelect, rowIndex) => {
        getData(row.UG_CODE)
        SetCode(row.UG_CODE);
        setDisabled(true)
        setDisabledCode(true)
        setSaveEnable(false)
        setmodal_xlarge(!modal_xlarge);
        setCrEnable(true)
        SetDetailsEnable(true)

    }
    //*** End of getSelectedRow function */

    //edit button function    
    const handleEdit = e => {
        setDisabled(false)
        setDisabledCode(true)
        setSaveEnable(true)
        SetDetailsEnable(false)
        SetEditEnable(false)

    }

    //new button function
    const handleNew = e => {
        // e.preventDefault()
        ClearItem();
        setShow(false)
        setSaveEnable(true)
        setCrEnable(false)
        SetDetailsEnable(false)

    }

    //clear fields function    
    const ClearItem = () => {
        SetCode("")
        //setarRow(initialTable)
        SetDescription("")
        SetActive(true)
        setDisabledCode(false)
        setDisabled(false)
        setCrEnable(false)
        setErrorMsg('')

        setAccess(true)
        setModify(true)
        setDele(true)
        setProcess(true)
        setPrint(true)
        setCreate(true)
        Settable(true)
        setTimeout(() => {
            setAccess(false)
            setModify(false)
            setDele(false)
            setProcess(false)
            setPrint(false)
            setCreate(false)
            //setarRow(initialTable)
        }, 1000)
        setReason("Created")
        SetEditEnable(false)
        SetAddNew(true)

        setCurrentPage(1)

    }

    //********Delete button function */
    const handleDelete = () => {

        if (menuDelete == false) {
            SetDpDescription("You don't have permission to Delete !");
            SetDpAlertShow(true)
            return
        }

        const rowDelete = {
            "strMenuCode": menuCode,
            "strCode": strUGroupCode,
            "strLoggedCompany": LogCompanyCode,
            "strLoggedLocation": LocationCode,
            "strReason": Reason,
            "strCreateBy": crBy
        }
        //loading alert show
        SetLoadingAlert(true)
        SetLoadingAlerttitle("Deleting...")


        fetch(`${ApiURL}Common/Delete`,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${authToken}`
                },
                body: JSON.stringify(rowDelete)
            }
        ).then(Response => {
            if (Response.status == "200") {
                SetLoadingAlert(false)
                Response.json()
                    .then(responseData => {

                        if (responseData.data == "Cannot Delete, Record Already Used!") {
                            displayAlertMessage('warning', responseData.data)
                        } else {
                            ClearItem();
                            displayAlertMessage('success', responseData.data)
                        }
                    }
                    )
            } else if (Response.status == "400") {
                SetLoadingAlert(false)
                Response.json()
                    .then(responseData => {
                        setErrorMsg(responseData.msg)
                    })
                setDisabled(false)
                setDisabledCode(false)
                displayAlertMessage('danger', "Error !")

            } else {
                SetLoadingAlert(false)
                ClearItem()
            }
        }).catch(error => {
            console.log(error.message)
        })
    }
    //*********Delete button function end */


    //**********Table Object */
    const UserGroupDetBuilder = (strUGroupCode, menu, permission) => {
        return {
            "UGD_CODE": strUGroupCode,
            "UGD_MENUTAG": menu,
            "UGD_MENURIGHT": permission,
        }
    }


    //**Permission Check */
    const permission = (operation) => {
        const permissiondata = {
            strUsername: permissionName,
            strPassword: permissionPassword,
            strLocation: LocationCode,
            strMenuCode: menuCode
        }

        clearPermissionInputs()

        fetch(`${ApiURL}login/userpermission`,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${authToken}`
                },
                body: JSON.stringify(permissiondata)
            }
        ).then(Response => {
            if (Response.status == "200") {
                Response.json()
                    .then(responseData => {
                        let Access = (responseData.data.strMenuAccessRight)
                        let Create = (responseData.data.strMenuCreateRight)
                        let Delete = (responseData.data.strMenuDeleteRight)
                        let Modify = (responseData.data.strMenuModifyRight)
                        let Print = (responseData.data.strMenuPrintRight)
                        let Process = (responseData.data.strMenuProcessRight)

                        if (operation == "Save") {
                            if (Create == true) {
                                handlesave()
                            } else if (Modify == true) {
                                handlesave()
                            } else {
                                if (operation == "Save" && addNew == true) {
                                    displayAlertMessage('danger', "This user dosen't have permission to save")
                                } else {
                                    displayAlertMessage('danger', "This user dosen't have permission to edit")
                                }
                            }
                        } else if (operation == "Delete") {
                            if (Delete == true) {
                                handleDelete()
                            } else {
                                displayAlertMessage('danger', "This user don't have permission to delete !")
                            }
                        } else if (operation == "Print") {
                            if (Print == true) {
                                Printdata()
                            } else {
                                displayAlertMessage('danger', "This user don't have permission to print !")
                            }
                        }
                    }
                    )

            } else if (Response.status == "400") {
                setDisabled(false)
                setDisabledCode(false)
                displayAlertMessage('danger', "Oops something went wrong !")
                clearPermissionInputs()

            } else if (Response.status == "403") {
                setDisabled(false)
                setDisabledCode(false)
                displayAlertMessage('danger', "You have not Permission to make changes !")
                clearPermissionInputs()

            } else if (Response.status == "404") {
                setDisabled(false)
                setDisabledCode(false)
                displayAlertMessage('danger', "Password or User Name is Invalid !")
                clearPermissionInputs()

            } else {
                ClearItem()
            }
        }).catch(error => {
            console.log(error.message)
        })
    }


    //Function for displaying Alert Messages.
    function displayAlertMessage(color, message) {
        setAlertColor(color)
        setAlertMsg(message)
        setShow(true)

        setTimeout(() => {
            setShow(false)
        }, time)
    }


    //handle permission alert
    function handlePermissionAlert(LogUserType, reason, disable, alertShow) {
        setPermissionName(LogUserType)
        setReason(reason)
        setPermissionNameDisable(disable)
        setPermissionAlertShow(alertShow)
    }


    //Clear permission name & password
    function clearPermissionInputs() {
        setPermissionName("");
        setPermissionPassword("");
        setReason("");
    }


    //Handle Favourite Button
    const handleFavourite = async () => {
        var response = await addtoFavourite(menuCode, LogUserType);
    }


    const validateSpecialCharacters = (str) => {
        const specialCharRegex = /[!@#$%^&*(),.?":{}|<>]/;
        return specialCharRegex.test(str);
    };


    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTags>
                    <title>User Groups Master</title>
                </MetaTags>
                <Container fluid={true}>
                    <Breadcrumb title="Master Files" breadcrumbItem="User Groups Master"></Breadcrumb>
                    <DPAlert
                        confirm_both={sweetAlertShow}
                        title={"User Group Master !"}
                        description={AlertDescription}
                        showCancel={true}
                        btnColor={"success"}
                        cancelColor={"danger"}
                        onConfirm={() => {
                            setsweetAlertShow(false)
                            if (AlertConfirmOption == 1) {

                                if (addNew == true && menuCreate == true && permissionReasonShow == false) {
                                    handlesave()
                                } else if (addNew == true && menuCreate == true && permissionReasonShow == true) {
                                    handlePermissionAlert(LogUserType, "Created", true, true)
                                } else if (addNew == false && menuModify == true && permissionReasonShow == false) {
                                    handlesave()
                                } else if (addNew == false && menuModify == true && permissionReasonShow == true) {
                                    handlePermissionAlert(LogUserType, "Updated", true, true)
                                } else {
                                    setPermissionReasonShow(true)
                                    setPermissionAlertShow(true)
                                }

                            } else if (AlertConfirmOption == 2) {
                                handleEdit()
                            } else if (AlertConfirmOption == 3) {
                                window.location.href = "/";
                            } else if (AlertConfirmOption == 4) {
                                handleNew()
                            } else if (AlertConfirmOption == 5) {

                                if (addNew == false && menuDelete == true && permissionReasonShow == false) {
                                    handleDelete()
                                } else if (addNew == false && menuDelete == true && permissionReasonShow == true) {
                                    handlePermissionAlert(LogUserType, "Deleted", true, true)
                                } else {
                                    setPermissionReasonShow(true)
                                    setPermissionAlertShow(true)
                                }
                            }

                        }}
                        onCancel={() => {
                            setsweetAlertShow(false)
                            clearPermissionInputs()
                        }}
                    />
                    <DPPermission
                        confirm_both={permissionAlertShow}
                        title={menuName}
                        description={permissionAlertTitle}
                        showReason={permissionReasonShow}
                        nameDisable={permissionNameDisable}
                        showCancel={true}
                        btnColor={"success"}
                        cancelColor={"danger"}
                        AlName={permissionName}
                        AlNameOnchange={e => {
                            let val2 = Text(e.target, 50, true, false, "any", true)
                            setPermissionName(val2)
                        }}
                        AlPassward={permissionPassword}
                        AlPasswardOnchange={e => {
                            let val2 = Text(e.target, 50, true, true, "any", true)
                            setPermissionPassword(val2)
                        }}
                        AlReason={Reason}
                        AlReasonOnchange={e => {
                            let val2 = Text(e.target, 50, true, false, "any", true)
                            setReason(val2)
                        }}
                        onConfirm={() => {
                            setPermissionAlertShow(false)
                            if (AlertConfirmOption == 1) {
                                permission("Save")
                            } else if (AlertConfirmOption == 5) {
                                permission("Delete")
                            } else if (AlertConfirmOption == 6) {
                                permission("Print")
                            }
                        }}
                        onCancel={() => {
                            setPermissionAlertShow(false)
                            clearPermissionInputs()
                        }}
                    />
                    <DPAlert
                        confirm_both={dpAlertShow}
                        title={menuName}
                        description={dpDescription}
                        showCancel={false}
                        btnColor={"success"}
                        cancelColor={"danger"}
                        onConfirm={() => {
                            SetDpAlertShow(false)
                        }}
                        btnYes={"OK"}
                    />
                    <DPLoadingAlert
                        confirm_both={loadingAlert}
                        title={loadingAlertTitle}
                    />
                    <Row>
                        <Col lg={12}>
                            <Card>
                                <CardBody>
                                    <DPTopToolBar
                                        //Help Button
                                        helpEnable={helpUrl != "" ? true : false}
                                        helpClick={() => {
                                            window.open(helpUrl)
                                        }}
                                        //Favorite Button
                                        favoriteEnable={true}
                                        favoriteClick={handleFavourite}
                                        //New Button
                                        newEnable={true}
                                        newClick={() => {
                                            setAlertDescription("Do you wish to refresh the screen ?");
                                            setAlertConfirmOption(4)
                                            setsweetAlertShow(true)
                                        }}
                                        //Save Button
                                        saveEnable={saveEnable && isHeadOffice}
                                        saveClick={() => {
                                            setAlertDescription("Do you wish to save ?");
                                            setAlertConfirmOption(1)
                                            setsweetAlertShow(true)
                                        }}
                                        //ProcessButton
                                        processEnable={false}
                                        processClick={() => {
                                            alert("Process")
                                        }}
                                        //Edit Button
                                        editEnable={editEnable && isHeadOffice}
                                        editClick={() => {
                                            setAlertDescription("Do you wish to edit ?");
                                            setAlertConfirmOption(2)
                                            setsweetAlertShow(true)
                                        }}
                                        //Print Button
                                        printEnable={false}
                                        printClick={() => {
                                            alert("Print")
                                        }}
                                        //Delete Button
                                        deleteEnable={deleteEnable}
                                        deleteClick={() => {
                                            setReason("Delete")
                                            setAlertDescription("Do you wish to delete ?");
                                            setAlertConfirmOption(5)
                                            setsweetAlertShow(true)
                                        }}
                                        //Exit Button
                                        exitEnable={true}
                                        exitClick={() => {
                                            setAlertDescription("Do you wish to exit ?");
                                            setAlertConfirmOption(3)
                                            setsweetAlertShow(true)
                                        }}
                                    />
                                    <Row>
                                        <UserGroupsMasterContent
                                            GetSelectRow={GetSelectRow}
                                            CodeValue={strUGroupCode}
                                            CodeonChange={e => {
                                                let val1 = Text(
                                                    e.target,
                                                    5,
                                                    true,
                                                    false,
                                                    "upper",
                                                    false
                                                )
                                                SetCode(val1)
                                            }}
                                            DescValue={strUGroupDesc}
                                            DescOnChange={e => {
                                                let val2 = Text(
                                                    e.target,
                                                    50,
                                                    true,
                                                    false,
                                                    "any",
                                                    true
                                                )
                                                SetDescription(val2)
                                            }}
                                            ActiveSw={IsActive}
                                            SwonChange={() => {
                                                SetActive(!IsActive)
                                            }}
                                            modelTrigger={tog_xlarge}
                                            modelOpen={modal_xlarge}
                                            show={show}
                                            disabled={disabled}
                                            disabledCode={disabledCode}
                                            AlertColor={AlertColor}
                                            AlertMsg={AlertMsg}
                                            CodeOnBlur={e => {
                                                getData(e.target.value)
                                                if (strUGroupCode == "") {
                                                    SetDescription("")
                                                    SetActive(true)
                                                    setAccess(true)
                                                    setModify(true)
                                                    setDele(true)
                                                    setProcess(true)
                                                    setPrint(true)
                                                    setCreate(true)

                                                    setTimeout(() => {
                                                        setAccess(false)
                                                        setModify(false)
                                                        setDele(false)
                                                        setProcess(false)
                                                        setPrint(false)
                                                        setCreate(false)
                                                    }, 1)
                                                }
                                            }}
                                            ErrorMsg={ErrorMsg}
                                            menuCode={menuCode}

                                        />
                                    </Row>
                                    <Row className="mb-2"></Row>
                                    <Row>
                                        <UserGroupDetNew
                                            DataRow={arRow}
                                            Disable={detailsEnable}

                                            setModify={setModify}
                                            setAccess={setAccess}
                                            setDele={setDele}
                                            setProcess={setProcess}
                                            setPrint={setPrint}
                                            setCreate={setCreate}

                                            create1={create1}
                                            print1={print1}
                                            modify1={modify1}
                                            process1={process1}
                                            access1={access1}
                                            dele1={dele1}

                                            GroupCode={strUGroupCode}
                                            setarRow={setarRow}
                                            menuTable={menuTable}
                                            table={table}
                                            initialTable={initialTable}

                                            currentPage={currentPage}
                                            setCurrentPage={setCurrentPage}
                                            clearOnEdit={clearOnEdit}
                                        />
                                    </Row>
                                    <Row>
                                        {crEnable ? (
                                            <DPInfoBox
                                                createdBy={crBy}
                                                createdOn={crDate != '1900-01-01T00:00:00' ? crDate : ''}
                                                modifiedBy={mdBy}
                                                modifiedOn={mdDate != '1900-01-01T00:00:00' ? mdDate : ''}
                                            />
                                        ) : null}
                                    </Row>

                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>

        </React.Fragment>
    )

}

export default UserGroupsMaster
